import {Component, Watch} from "vue-property-decorator";
import renderUtils from "@/components/RenderUtils";
import MergeHooks from "@/decorators/mergeHooks";
import {ProductionPlanTypeServiceProxy, RecordRemarkDTO} from "@/service-proxies/app-v2/coproduction.service-proxies";
import {ProductTypeServiceProxy} from "@/service-proxies/app-v2/product.service-proxies";
import {ProductionPlanTypeProductTypeServiceProxy} from "@/service-proxies/app-v2/coproduction.service-proxies";

const pptsp = new ProductionPlanTypeServiceProxy();
const ptsp = new ProductTypeServiceProxy();
const pptptsp = new ProductionPlanTypeProductTypeServiceProxy();
@Component
@MergeHooks
export default class WorkstationGroup extends renderUtils {
    sourceData = [];
    options = [];
    dict = new Map();
    visible = false;
    editdata: any = {};
    langLibrary = [];

    get languages() {
        return this.langLibrary.reduce((langs, lang) => {
            langs[lang.name] = {
                type: "input",
                label: `${this.$t(lang.name)}${this.$t("title")}`,
            };
            return langs;
        }, {});
    }

    get schema() {
        return {
            productTypes: {
                label: this.$t("page_language_setting_product_type"),
                type: "select",
                props: {
                    mode: "multiple",
                },
                options: this.options,
            },
            ...this.languages,
            startWorkModel: {
                label: this.$t("page_language_setting_mode"),
                type: "radio",
                props: {
                    radioStyle: {
                        display: "block",
                        height: "40px",
                        lineHeight: "40px",
                    },
                },
                on: {
                    change: (tar, e, arr) => {
                        if (tar.target.value === 3) {
                            e.setFieldsValue({paigong: 0})
                        }
                        this.schema.paigong.props.disabled = tar.target && tar.target.value == 3;
                    }
                },
                options: [
                    {
                        label: this.$t("page_language_setting_mode1"),
                        value: 1,
                    },
                    {
                        label: this.$t("page_language_setting_mode2"),
                        value: 2,
                    },
                    {
                        label: this.$t("page_language_setting_mode3"),
                        value: 3,
                    },
                ],
            },
            paigong: {
                label: this.$t('page_plan_process_assign_1'),
                type: "radio",
                defaultValue: 1,
                props: {
                    disabled: false,
                    radioStyle: {
                        display: "block",
                        height: "40px",
                        lineHeight: "40px",
                    },
                },
                options: [
                    {
                        label: this.$t("page_not_start"),
                        value: 0,
                    },
                    {
                        label: this.$t("page_authority_enable"),
                        value: 1,
                    },
                ],
            },
        };
    }

    render() {
        return (
            <blank-view>
                {this.renderSettingTable()}
                {this.renderAddModal()}
            </blank-view>
        );
    }

    renderSettingTable() {
        const props = {
            rowKey: "id",
            canFixedHead: false,
            dataSource: this.sourceData,
            columns: [
                {
                    title: this.$t("edit"),
                    dataIndex: "edit",
                    customRender: (items, record) => {
                        if (record.id) {
                            return <a onClick={() => this.openEditModal(record)}>{this.$t("edit")}</a>
                        }
                    }
                },
                {
                    title: this.$t("page_control_category"),
                    dataIndex: "name",
                    width: 300,
                    customRender: (text) => this.$t(text),
                },
                {
                    title: this.$t("page_language_setting_product_type"),
                    dataIndex: "productTypes",
                    customRender: (items, record) => {
                        if (record.id) {
                            return items.map((item) => this.dict.get(item)).join(",")
                        }
                    }
                },
                {
                    title: this.$t("page_language_setting_mode"),
                    dataIndex: "startWorkModel",
                    width: 200,
                    customRender: (text, record) => {
                        if (record.id) {
                            if (text == 1) {
                                return this.$t("page_language_setting_single")
                            } else if (text == 2) {
                                return this.$t("page_language_setting_multiple")
                            }
                            return this.$t("page_language_setting_multiple_limited_quantity")
                        }
                    }
                },
                {
                    title: this.$t('page_plan_process_assign_1'),
                    dataIndex: "processAssignMode",
                    width: 200,
                    customRender: (text, record) => {
                        if (record.id) {
                            return this.$t(
                                text == 0
                                    ? "page_not_start"
                                    : "page_authority_enable"
                            )
                        }
                    }
                },
            ]
            // actions: {
            //   edit: {
            //     action: this.openEditModal,
            //     customRender: (text,record) => {
            //       if(record.id) {
            //         return ''
            //       }
            //     }
            //     // acl: ,
            //   },
            // },
        };
        return this.renderTable(props);
    }

    renderAddModal() {
        const props = {
            title: this.$t("edit"),
            show: this.visible,
            schema: this.schema,
            editdata: this.editdata,
            ok: this.onSubmit,
            ref: "form",
            cancel: () => (this.visible = false),
            footer: "default",
        };
        return this.renderDialogWithForm(props);
    }

    mounted() {
        this.lodaData();
    }

    async lodaData() {
        this.langLibrary = this.$store.state.i18n.langLibrary;
        const {records} = await ptsp.getPageProductTypes(
            1,
            undefined,
            undefined,
            -1,
            2
        );
        const data = await pptsp.getProductionPlanTypeInfo();
        const dict = new Map();
        const options = [];
        for (let record of records) {
            dict.set(record.id, record.name);
            options.push({
                label: record.name,
                value: record.id,
            });
        }
        this.options = options;
        this.dict = dict;
        // this.sourceData = data;

        let dataLength = data.length;
        let copy = JSON.parse(JSON.stringify(data));
        let needPush = 0;
        if (dataLength < 30) {
            needPush = 30 - dataLength;
            for (var k = 0; k < needPush; k++) {
                let obj = {
                    // id: 'none'
                }
                copy.push(obj)
            }
        }

        this.sourceData = JSON.parse(JSON.stringify(copy));

    }

    async openEditModal({id, name, productTypes, startWorkModel}) {
        console.log("属性值：", id, name, productTypes, startWorkModel)
        const res = await pptsp.getCurrentTypeInfo(id);
        const languageInfo = res.languageInfo
        this.schema.paigong.defaultValue = res.processAssignMode
        this.schema.paigong.props.disabled = (startWorkModel == 3);
        const merge = languageInfo.reduce((res, lang) => {
            res[lang.languageType] = lang.value;
            return res;
        }, {});

        this.editdata = {
            planTypeId: id,
            source: "plan",
            productTypes,
            startWorkModel,
            ...merge,
        };
        // console.log(this.editdata)
        this.visible = true;
    }

    async onSubmit(value) {
        const omits = ["productTypes", "planTypeId", "source", "startWorkModel"];
        const data = {
            productTypeIds: value.productTypes,
            planTypeId: value.planTypeId,
            source: value.source,
            startWorkModel: value.startWorkModel,
            processAssignMode: value.paigong,
            languageList: Object.keys(value).reduce((res, key) => {
                if (!omits.includes(key)) {
                    res.push({
                        languageName: key,
                        textValue: value[key],
                    });
                }
                return res;
            }, []),
        };
        console.log("data:", data)
        await pptptsp.insertProductionTypeProductTypeLanguage(data as any);
        this.$message.success(this.$t("save_success"));
        this.visible = false;
        setTimeout(() => location.reload(), 500);
    }
}
